// src/components/DarkModeToggle.js
import React, { useEffect, useState } from "react";

const DarkModeToggle = () => {
  const [darkMode, setDarkMode] = useState(false);

  // On mount, check localStorage
  useEffect(() => {
    const savedMode = localStorage.getItem("darkMode") === "true";
    setDarkMode(savedMode);
    document.body.classList.toggle("dark-mode", savedMode);
  }, []);

  const toggleDarkMode = () => {
    const newMode = !darkMode;
    setDarkMode(newMode);
    document.body.classList.toggle("dark-mode", newMode);
    localStorage.setItem("darkMode", newMode);
  };

  return (
    <div className="dark-mode-toggle" onClick={toggleDarkMode}>
      <div className={`toggle-thumb ${darkMode ? "active" : ""}`} />
    </div>
  );
};

export default DarkModeToggle;
